export default __webpack_public_path__ + "static/favicon-2297e1596b47e40263c06f7592352e69.ico";